import {useQuery} from "@apollo/client";
import meQuery from "../_queries/meQuery";

export default () => {
    const {data: {me} = {}, loading} = useQuery(meQuery, {
        pollInterval: 60 * 1000,
    });

    return {
        me: me !== null ? me : undefined,
        loading: typeof me === 'undefined' && loading
    };
}